import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    if (
      !location.pathname.includes('report-dashboard') &&
      !location.pathname.includes('/joon-device/view')
    ) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;
